import React, { useState } from 'react';

import { ILanguage } from '@/interfaces/languages';
import { classNames } from '@/shared/helpers';
import LanguageList from './components/LanguageList';
import arrowDownIcon from '@/static/images/arrowdown.svg';
import { IStaticLocale } from '@/interfaces/staticlocale';

interface Props {
  locale: IStaticLocale;
  languages: ILanguage[];
  currentLanguage: ILanguage;
  currentPath: string;
  shouldApplyContrast: boolean;
}

const LanguageSelector = (props: Props) => {
  const {
    locale,
    languages,
    currentLanguage,
    currentPath,
    shouldApplyContrast,
  } = props;

  return (
    <div className="anim-drop-down-item languages">
      <div
        role="button"
        id="responsive-navbar-languages-handler"
        className="selected-language"
      >
        <div className="language-details">
          <img
            src={currentLanguage.icon}
            alt={`${currentLanguage.lang} icon`}
          />
          <p>{currentLanguage.lang.toUpperCase()}</p>
        </div>

        <img
          className={classNames(shouldApplyContrast && 'image-with-contrast')}
          src={arrowDownIcon}
          alt={locale.header.arrow_down_icon}
        />
      </div>

      <LanguageList
        currentLanguage={currentLanguage}
        currentPath={currentPath}
        languages={languages}
      />
    </div>
  );
};

export default LanguageSelector;
